import actionsTypes from "../constants/ActionTypes";

const initialState = {
    urlProfilePhoto: null,
    publicCode: null
}

export const UserReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case actionsTypes.URL_PROFILE_PHOTO:
            return {
                ...state,
                urlProfilePhoto: action.urlProfilePhoto
            };
        case actionsTypes.PUBLIC_CODE:
            return {
                ...state,
                publicCode: action.publicCode
            };
        default:
            return state;
    }
};